import * as React from "react";

;
export const WarningBasic = (props: React.SVGProps<SVGSVGElement>) => <svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M11.266 14.94h1.495l.345-5.75V3.9H10.92v5.29l.345 5.75zm-.874 3.68a1.6 1.6 0 001.61 1.61 1.6 1.6 0 001.61-1.61 1.6 1.6 0 00-1.61-1.61 1.6 1.6 0 00-1.61 1.61z" fill="#100722" /></svg>;